/** National contacts default to Brazil; explicit international prefixes keep their DDI. */
export function getWhatsAppUrl(phone: string | null | undefined): string | undefined {
  const value = phone?.trim();
  if (!value) return undefined;

  let digits = value.replace(/\D/g, "");
  const international = value.startsWith("+") || value.startsWith("00");
  if (value.startsWith("00")) digits = digits.slice(2);
  if (!international && (digits.length === 10 || digits.length === 11)) digits = `55${digits}`;

  // Without a DDD/country code, do not guess the destination or offer a broken link.
  if (!/^[1-9]\d{7,14}$/.test(digits)) return undefined;
  if (!international && digits.length < 12) return undefined;
  return `https://wa.me/${digits}`;
}
